const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_3Pl2RSqJv',
  aws_user_pools_web_client_id: '4p8vo30ue3tebh7icabc5gtgkt',
  location_endpoint_auth: 'https://api-preview.location-service.preview.trustpower.io/v1',
  optimise_endpoint_auth: 'https://api-optimise-preview.optimise-domain.optimise-preview.trustpower.io/v1',
  smartmeter_endpoint_auth:
    'https://api-optimise-preview.optimise-domain.optimise-preview.trustpower.io/v1/internal/onboarding',
  billing_endpoint_auth: 'https://api-optimise-preview.optimise-domain.optimise-preview.trustpower.io/v1/internal',
  data_bucket: 'https://loop-optimise-instructions-preview.s3.eu-west-1.amazonaws.com',
  dashboard_url: 'https://webapp.loop-optimise.preview.trustpower.io',
  signup_simulation_mode: true,
  theme: 'Loop',
  showThemeToggle: true,
};
export default awsmobile;
